import React from 'react';
import { Button } from 'react-bootstrap';
import MembershipButton from '../../components/button/MembershipButton';
import ProjectListing from '../../components/orderListing/projectListing';
import ProjectListingControl from '../../components/orderListing/projectListingControl';
import Page from '../../components/page/Page';
import routes from '../../routes/constants';
import text from '../../text';
import Onboarding from './components/onboarding';
import { useRedirect } from '../../hooks/useRedirect';
export var DASHBOARD_PAGE_ID = 'dashboard';
export default function Dashboard() {
    var redirect = useRedirect();
    return /*#__PURE__*/ React.createElement(Page, {
        title: text('dashboard'),
        id: DASHBOARD_PAGE_ID,
        className: "d-flex flex-column"
    }, /*#__PURE__*/ React.createElement("div", {
        id: "PageTopwWrapper"
    }, /*#__PURE__*/ React.createElement(Page.Top, null, /*#__PURE__*/ React.createElement("h2", null, text('dashboard')), /*#__PURE__*/ React.createElement(Page.Top.Control, null, /*#__PURE__*/ React.createElement(MembershipButton, {
        variant: "outline-primary"
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        onClick: function() {
            return redirect.push(routes.mp.root);
        }
    }, text('order3DData')))), /*#__PURE__*/ React.createElement(ProjectListingControl, null)), /*#__PURE__*/ React.createElement(ProjectListing, null), /*#__PURE__*/ React.createElement(Onboarding, null));
}
